<button mat-mini-fab color="accent" class="alert-btn" [class.!bg-gray-300]="alertCount == 0" (click)="onClickOpenManageDialog()">
  @if (alertCount > 0) {
    <mat-icon
      [matBadge]="alertCount"
      matBadgeSize="small"
      aria-hidden="false"
      [matTooltip]="'Create a new alert for this currency. The badge shows how many alerts you’ve already set.'"
    >
      notifications
    </mat-icon>
  } @else {
    <mat-icon [matTooltip]="'Create a new alert for this currency.'">notifications</mat-icon>
  }
</button>
